import React, { Component } from 'react';
import Popup from '.././components/Popup';
import Header from '.././components/Header';
import Sidebar from '.././components/Sidebar';
import Clients from '.././components/css/dark/img/theme-images/clients.svg';
import FilterIcon from '.././components/css/dark/img/theme-images/filter_icon.svg';
import DeleteIcon from '.././components/css/dark/img/theme-images/delete.svg';
import CreateNewFilter from '../components/CreateNewFilter';
import EditFilter from '../components/EditFilter';
import DeletePopup from '../components/ConfirmDeletePopup';
import $ from 'jquery';
import { userService } from '../_services';
import { Redirect } from "react-router-dom";

class Tools extends Component {
    constructor(props) {
        super(props);
        try {
            this.state = {
                dashboardName: JSON.parse(localStorage.getItem('user')).dList[0].dashboardName,
                userdata: JSON.parse(localStorage.getItem('user')),
                CreateNewFilter: false,
                EditFilter: false,
                DeletePopup: false,
                ConfirmSection: true,
                UserFilterList: [],
                SelectedFilterId: 0,
                SelectedFilterName: '',
                LoadTime: new Date(),
                filterId: ''
            };
            localStorage.setItem('Page_Path', '/filter');
        }
        catch (error) { }
        this.CreateNewFilter = this.CreateNewFilter.bind(this);
        this.OpenEditFilter = this.OpenEditFilter.bind(this);
    }
    componentDidMount() {
        try {
            // document.title = 'Filter Page';
            this.GetUserFilterSet('', '', this.state.userdata["dList"][0].dashboardId);
            $(".analytics-menu").click(e => {
                if ($('.collapseButton').hasClass("active")) {
                    this.handleCollapse();
                    $('.sidebar-submenu').show();
                    $('body').toggleClass('sub-menu-active');
                }
            });
            //setTimeout(function () {
            //    const hasScrollbar = document.body.scrollHeight > window.innerHeight;
            //    if (!hasScrollbar) {
            //        $('body').addClass('hide-scroller');
            //    }
            //}, 300);

        } catch (error) { }
    }
    componentDidUpdate() {
        if (this.state.UserFilterList == []) {
            this.GetUserFilterSet('', '', this.state.userdata["dList"][0].dashboardId);
        }
    }
    componentWillUnmount() {
       // $('body').removeClass('hide-scroller');
    }
    GetUserFilterSet(FilterName, FilterJson, DashboardId) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
                body: JSON.stringify({ FilterName, FilterJson, DashboardId })
            };
            return fetch(`/api/Filter/GetUserAdFilter`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        this.setState({ UserFilterList: apidata[0]["filterset"] });
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    RemoveSelectedUserFilter(fid, dashid, fname) {
        try {
            fname = '';
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ fid, dashid, fname})
            };
            return fetch(`/api/Filter/RemovUserAdFilter`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        this.setState({ DeletePopup: !this.state.DeletePopup});
                        this.GetUserFilterSet('', '', dashid);
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }

    CreateNewFilter() {
        if (this.state.CreateNewFilter === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    CreateNewFilter: !this.state.CreateNewFilter,
                });
                if (this.state.CreateNewFilter == false) {
                    this.GetUserFilterSet('', '', this.state.userdata["dList"][0].dashboardId);
                }
            }, 500)
        } else {
            this.setState({
                CreateNewFilter: !this.state.CreateNewFilter,
            });
            if (this.state.CreateNewFilter == false) {
                this.GetUserFilterSet('', '', this.state.userdata["dList"][0].dashboardId);
            }
        }
    }

    OpenEditFilter(e) {
        if (this.state.EditFilter == false) {
            try {
                let fdata = this.state.UserFilterList.filter((x) => x["dashboardId"] == parseInt($(e.target.parentElement).attr('filterid')));
                if ($(e.target).text() == '' || $(e.target).text() == undefined || $(e.target).text() == null) {
                    this.setState({
                        SelectedFilterId: parseInt($(e.target).attr('filterid')), SelectedFilterName: $(e.target).attr('filtername'), UserFilterList: fdata
                    });
                }
                else {
                    this.setState({
                        SelectedFilterId: parseInt($(e.target).attr('filterid')), SelectedFilterName: $(e.target).text().replace("Delete this filter", ""), UserFilterList: fdata
                    });
                }
            }
            catch (error) { }
        }
        this.GetUserFilterSet('', '', this.state.userdata["dList"][0].dashboardId);
        if (this.state.EditFilter === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    EditFilter: !this.state.EditFilter
                });
            }, 500)
        } else {
            this.setState({
                EditFilter: !this.state.EditFilter
            });
        }
        //if (this.state.EditFilter == true) {
        //    window.location.reload();
        //}
    }
    toggleSubDisPopup() {
        var wname = this.state.userdata.wholesaler;
        this.setState({
            SubDisshowPopup: !this.state.SubDisshowPopup,
            dashboardName: wname
        });
    }
    DeleteSelectedFilter = e => {
        e.stopPropagation();
        this.RemoveSelectedUserFilter(parseInt(this.state.filterId), parseInt(this.state.userdata["dList"][0].dashboardId), $(e.target).attr('filtername'));
    }
    deletePopup = e => {
        e.stopPropagation();
        let filterId = $(e.target).attr('filterid');
        this.setState({ filterId: filterId });
        if (this.state.DeletePopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    DeletePopup: !this.state.DeletePopup,
                });
            }, 500)
        } else {
            this.setState({
                DeletePopup: !this.state.DeletePopup,
            });
        }
    }
    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css({ 'width': 'auto', 'overflow': 'visible' });
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function () {
                $(".collapseButton").removeClass('active');
                $(".tierMilestone .range").removeClass('active');
            });
            $(".tool-section").animate({
                marginLeft: 313 + 'px'
            }, 1000);
            $(".sidebar-section").removeClass('intro');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function () {
                $(".menu-text").css({ 'width': '0px', 'overflow': 'hidden' });
                $('.sidebar-submenu').hide();
                if ($('body').hasClass("sub-menu-active")) {
                    $('body').toggleClass('sub-menu-active');
                }
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function () {
                $(".collapseButton").addClass('active');
                $(".tierMilestone .range").addClass('active');
            });
            $(".tool-section").animate({
                marginLeft: 133 + 'px'
            }, 1000);
            $(".sidebar-section").addClass('intro');
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }

    render() {
        try {
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
        } catch (error) { }
        return (
            <div>
                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                <Header />
                <Sidebar AnalyticList={this.props.AnalyticData} />
                <div className="tool-section filter">                   

                    <h2>Manage Filters <span className="beta-link"><span className="beta">Beta</span></span></h2>
                    {
                        this.state.UserFilterList != null?
                            <ul>
                                <li onClick={this.CreateNewFilter.bind(this)}><div className="manage-content"><img src={FilterIcon} alt="" />Create New Filter<span className="arrow">&nbsp;</span></div></li>
                                {this.state.UserFilterList.map((e1, i1) => {
                                    return (
                                        <li filterid={e1.dashboardId} filtername={e1.filterName} onClick={this.OpenEditFilter.bind(this)}>
                                            <div className="manage-content" filterid={e1.dashboardId} filtername={e1.filterName}><img src={FilterIcon} alt="" filtername={e1.filterName} filterid={e1.dashboardId} /><span className="text-gap" filtername={e1.filterName} filterid={e1.dashboardId}>{e1.filterName}</span><span filtername={e1.filterName} filterid={e1.dashboardId} onClick={this.deletePopup.bind(this)} ><a href="javascript:void('0')" className="custom-tooltip"><img className="filterDeleteIcon" filterid={e1.dashboardId} src={DeleteIcon} alt="delete Icon" /><span className="hover-tooltip delete">Delete this filter</span></a></span><span className="arrow" filterid={e1.dashboardId} >&nbsp;</span></div>
                                        </li>
                                    )
                                })}
                            </ul> : <ul><li onClick={this.CreateNewFilter.bind(this)}><div className="manage-content"><img src={Clients} alt="" />Create New Filter<span className="arrow">&nbsp;</span></div></li></ul>
                    }
                    {/*<li onClick={this.toggleDisPopup.bind(this)}><div className="manage-content"><img src={Clients} alt="" />Filter Set 1 <span className="arrow">&nbsp;</span></div></li>
                        <li onClick={this.toggleDisPopup.bind(this)}><div className="manage-content"><img src={Clients} alt="" />Filter Set 2 <span className="arrow">&nbsp;</span></div></li>*/}

                    {
                        this.state.CreateNewFilter ?
                            <CreateNewFilter calldata={"callonce"} text='Create New Filter' closePopup={this.CreateNewFilter.bind(this)} /> : null
                    }
                    {
                        this.state.EditFilter ?
                            <EditFilter calldata={"callonce"} text={this.state.SelectedFilterName} binddashid={this.state.SelectedFilterId} binddashboarddata={this.state.UserFilterList} closePopup={this.OpenEditFilter.bind(this)} /> : null
                    }
                    {
                        this.state.DeletePopup ?
                            <DeletePopup ConfirmSection={this.state.ConfirmSection} removeFilter={this.DeleteSelectedFilter} titleText="Are you sure want to delete this filter?" closePopup={this.deletePopup.bind(this)}  /> : null
                    }

                </div>
            </div>
        )

    }

}
export default Tools;